import * as THREE from 'three';
import { BoxLineGeometry } from 'three/examples/jsm/geometries/BoxLineGeometry.js';

export default class Room 
{
    constructor(scene)
    {
        this.scene = scene;
        this.size = new THREE.Vector3(800, 200, 800);
        this.setup();
    };

    setup()
    {
        this.room = new THREE.LineSegments(
            new BoxLineGeometry(this.size.x, this.size.y, this.size.z, 100, 100, 100 ),
            new THREE.LineBasicMaterial( { color: 0xEFD3D7 } )
        );
        this.room.geometry.translate(0, this.size.y/2, 0);
        this.scene.add(this.room);
    };

    update(time)
    {
        // this.room.material.color.setHSL(Math.sin(time), 0.5, 0.5);
    };

    getWidth()
    {
        return this.size.x;
    };

    getHeight()
    {
        return this.size.y;
    };
}